// Função para validar CPF
export const isValidCPF = (cpf: string): boolean => {
    cpf = cpf.replace(/\D/g, '');
    if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false;

    let sum = 0;
    let remainder;
    for (let i = 1; i <= 9; i++) {
        sum += parseInt(cpf.substring(i - 1, i)) * (11 - i);
    }
    remainder = (sum * 10) % 11;
    if (remainder === 10 || remainder === 11) remainder = 0;
    if (remainder !== parseInt(cpf.substring(9, 10))) return false;

    sum = 0;
    for (let i = 1; i <= 10; i++) {
        sum += parseInt(cpf.substring(i - 1, i)) * (12 - i);
    }
    remainder = (sum * 10) % 11;
    if (remainder === 10 || remainder === 11) remainder = 0;
    return remainder === parseInt(cpf.substring(10, 11));
};

export const isValidCNPJ = (cnpj: string): boolean => {
    cnpj = cnpj.toUpperCase().replace(/[^A-Z0-9]/g, '');
    if (cnpj.length !== 14) return false;

    // Valor de cada caractere conforme regra do CNPJ alfanumérico (RFB): código ASCII - 48.
    // Dígitos 0-9 mantêm o valor numérico ('0'=48->0 ... '9'=57->9); letras A-Z -> 17-42.
    const charValue = (c: string): number => c.charCodeAt(0) - 48;

    const validateDigit = (cnpj: string, position: number): boolean => {
        let sum = 0;
        const weights = position === 12 ? [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2] : [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
        for (let i = 0; i < weights.length; i++) {
            sum += charValue(cnpj.charAt(i)) * weights[i];
        }
        const remainder = sum % 11;
        return charValue(cnpj.charAt(position)) === (remainder < 2 ? 0 : 11 - remainder);
    };

    return validateDigit(cnpj, 12) && validateDigit(cnpj, 13);
};

export const validateCPFOrCNPJ = (value: string): boolean => {
    const cleanValue = value.toUpperCase().replace(/[^A-Z0-9]/g, '');
    return cleanValue.length <= 11 ? isValidCPF(cleanValue) : isValidCNPJ(cleanValue);
};
